import type { NotificationItem, NotificationsCount } from './types';

export type { NotificationsCount, NotificationItem };

function asPositiveInt(value: unknown): number | null {
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed < 1) return null;
  return parsed;
}

export function unwrapNotificationsCount(response: unknown): NotificationsCount {
  const record =
    response && typeof response === 'object'
      ? (response as { data?: unknown; conversations?: unknown })
      : null;
  const payload =
    record && record.data && typeof record.data === 'object'
      ? (record.data as { conversations?: unknown })
      : record;
  const raw = payload && Array.isArray(payload.conversations)
    ? payload.conversations
    : [];
  const conversations = raw.flatMap((item) => {
    if (!item || typeof item !== 'object') return [];
    const row = item as { id?: unknown; count?: unknown };
    const id = asPositiveInt(row.id);
    const count = Number(row.count);
    if (id == null || !Number.isInteger(count) || count < 1) return [];
    return [{ id, count }];
  });
  return { conversations };
}

type RawNotification = {
  id?: string | number;
  title?: string;
  body?: string;
  message?: string;
  isRead?: boolean;
  read?: boolean;
  createdAt?: string;
};

export function mapNotificationItem(raw: RawNotification): NotificationItem {
  return {
    id: raw.id == null ? '' : String(raw.id),
    title: raw.title ?? '',
    body: raw.body ?? raw.message ?? '',
    isRead: Boolean(raw.isRead ?? raw.read),
    createdAt: raw.createdAt ?? '',
  };
}

export function unwrapNotificationList(response: unknown): NotificationItem[] {
  const list = Array.isArray(response)
    ? response
    : response &&
        typeof response === 'object' &&
        'data' in response &&
        Array.isArray((response as { data?: unknown }).data)
      ? (response as { data: unknown[] }).data
      : response &&
          typeof response === 'object' &&
          'list' in response &&
          Array.isArray((response as { list?: unknown }).list)
        ? (response as { list: unknown[] }).list
        : [];

  return list.map((item) => mapNotificationItem(item as RawNotification));
}
